import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch } from 'react-router-dom';
import jwt from 'jsonwebtoken';

import { getCookie } from 'shared/utils/cookie';
import sitemap from 'shared/routes/sitemap';
// import sitemap from 'shared/routes/sitemapSellingOnly';

import NotFound from 'web/routes/NotFound';
import NotFoundMobile from 'mobile/routes/NotFoundMobile';

import {
  initialState,
  getMediaPlaylistRequest,
  setState,
} from 'shared/actions/webPlayer.action';
import { getSearchTypeRequest } from 'shared/actions/mediaInfo.action';
import { postRefreshTokenRequest } from 'shared/actions/auth.action';
import { pushModal, initModal } from 'shared/actions/modal.action';
// import { addScript } from 'shared/utils/channelTalk';

import withWebPlayer from 'web/libs/hoc/withWebPlayer';

import PublicRoute from 'shared/routes/PublicRoute';
import PrivateRoute from 'shared/routes/PrivateRoute';

import ChannelService from 'shared/utils/ChannelService';

@withWebPlayer
@withRouter
@connect(
  (state, props) => {
    let stateData = {
      auth: state.shared.auth,
      toast: state.shared.toast,
      modal: state.shared.modal,
    };
    if (!window.isMobile) {
      stateData.webPlayer = state.shared.webPlayer;
    }
    return stateData;
  },
  {
    initialState,
    getMediaPlaylistRequest,
    setState,
    getSearchTypeRequest,
    postRefreshTokenRequest,
    pushModal,
    initModal,
  },
)
class AppContainer extends Component {
  /**
   * 챗봇
   */
  addChannelIoScript = () => {
    const { user = {} } = this.props.auth;
    const access_token = getCookie('dr_access_token');
    let token = null;

    window.channelIo = ChannelService;
    // window.channelIo.loadScript();

    let channelSettings = { ...window.channelPluginSettings };
    if (access_token && user.type !== 'GUEST') {
      token = jwt.decode(access_token).uid;
      channelSettings.userId = token;
    }
    // console.log({ token: token, channelSettings });
    window.channelIo.boot(channelSettings);
    // console.log({ channelIo: window.channelIo });
  };

  componentDidMount() {
    // this.addChannelIoScript();

    window.addEventListener('offline', e => {
      console.log('offline - Swicher');
      this.props.pushModal({
        type: 'Disconnect',
      });
    });
    window.addEventListener('online', e => {
      console.log('online - Swicher');
      if (this.props.modal && this.props.modal.type === 'Disconnect') {
        this.props.initModal();
        console.log('WWWWWWWWWWWWWWWW');
      }
    });

    // console.log(`swicher`);
  }

  //라우터 구성하는 폼
  //siteMap의 카테고리 라우터 작동
  generateMenuRouter = (auth, array, sitemapList, stockPath) => {
    if (!stockPath) {
      stockPath = '';
    }
    const deviceType = window.isMobile ? 'mobile' : 'desktop';

    /**
     * web / mobile 의 sitemap의 값의 따라 페이지를 설정
     * menu의 children이라는 객체가 있으면 generateMenuRouter 함수를 실행,
     * 그게 아니라면 options들의 기본값을 설정
     */
    return sitemapList.forEach(menu => {
      if (Array.isArray(menu.children)) {
        this.generateMenuRouter(
          auth,
          array,
          menu.children,
          `${stockPath}/${menu.path}`,
        );
      } else {
        const option = {};
        option.key = `router-${stockPath}-${menu.path}`;
        option.exact = !menu.exact ? false : true;
        option.path = `${stockPath}/${menu.path}`;
        option.component = menu[deviceType];

        option.auth = this.props.auth;
        option.grade = menu.grade;
        option.pushToastApp = this.props.pushToastApp;
        option.pushModal = this.props.pushModal;
        option.addChannelIoScript = this.addChannelIoScript;

        if (window.isMobile) {
          //jwplayer의 사용여부
          option.jwplayer = null;
          //해당 페이지의 hasWebplayer를 설정할지
          option.hasWebplayer = null;
          //해당 페이지의 webplayer를 보여줄지 안보여줄지
          option.webPlayer = null;
          //isPlayer ??
          option.isPlayer = null;
          //state ??
          option.setState = null;
          //initialState ?? (현재 사용하고 있는 페이지 없음)
          option.initialState = null;
          //getMediaPlaylistRequest ?? (현재 사용하고 있는 페이지 없음)
          option.getMediaPlaylistRequest = null;
        } else {
          option.jwplayer = this.props.jwplayer;
          // option.hasWebplayer = menu.webplayer; // 유저 상태도 참조하도록 변경
          option.webPlayer = this.props.webPlayer;
          option.isPlayer = menu.isPlayer;
          option.setState = this.props.setState;
          option.initialState = this.props.initialState;
          option.getMediaPlaylistRequest = this.props.getMediaPlaylistRequest;
        }

        /**
         * 유료회원이면서 webplayer가 true면
         * option.hasWebplayer = true 셋팅
         */
        if (auth.user.userPurchase === 'PAID' && menu.webplayer) {
          option.hasWebplayer = true;
        }

        let route = <PrivateRoute {...option} />;
        /**
         * 페이지가 공통인 부분
         */
        if (menu.public) {
          option.public = menu.public;
          route = <PublicRoute {...option} />;
        }
        array.push(route);
      }
    });
  };

  render() {
    const { auth } = this.props;
    let routers = [];
    this.generateMenuRouter(auth, routers, sitemap.menu);

    return (
      <>
        <Switch>
          {routers}
          {window.isMobile ? (
            <NotFoundMobile history={this.props.history} />
          ) : (
            <NotFound history={this.props.history} />
          )}
        </Switch>
      </>
    );
  }
}

export default AppContainer;
